
import {
  LogOut,
  File,
  ClipboardCheck,
  User,
  MessageCircle,
  ScanSearch,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import logoUrl from "../../assets/logo.png";
import { useSuperAdmin } from "../../hooks/useSuperAdmin";
import { useOrganizationStore } from "../../store/useOrganizationStore";
import { clearSessionOnLogout } from "../../utils/clearSessionOnLogout";

interface HeaderProps {
  title?: string;
  showNavigation?: boolean;
}

export default function Header({ title, showNavigation = true }: HeaderProps) {
  const { authStatus } = useAuthenticator();
  const { isSuperAdmin } = useSuperAdmin();
  const { organizations, activeOrgId } = useOrganizationStore();
  const activeOrg = organizations.find((o) => o.orgId === activeOrgId);
  const navigate = useNavigate();
  const { signOut } = useAuthenticator();

  return (
    <div className="header">
      <div className="header-container">
        <div className="header-left">
          <Link to="/" className="logo-section">
            <img src={logoUrl} alt="ManufactureAI" className="header-logo" />
            <span className="brand-text">ManufactureAI</span>
          </Link>
          {authStatus === "authenticated" && activeOrg && (
            <span className="ml-3 flex items-center gap-1.5 text-sm text-slate-400 min-w-0 max-w-[180px]">
              <span className="text-slate-500">·</span>
              <span className="truncate">{activeOrg.name}</span>
            </span>
          )}
        </div>

        {title && (
          <div className="header-center">
            <h1 className="page-title">{title}</h1>
          </div>
        )}

        {showNavigation && (
          <div className="header-actions">
            <Link to="/sop-dashboard" className="header-nav-link">
              <File className="w-4 h-4" />
              <span>SOPs</span>
            </Link>
            {isSuperAdmin && (
              <Link
                to="/sops/pending-verification"
                className="header-nav-link"
                title="Pending Verification"
              >
                <ClipboardCheck className="w-4 h-4" />
                <span>Pending</span>
              </Link>
            )}
            {isSuperAdmin && (
              <Link to="/rma/pending-review" className="header-nav-link" title="RMA pending review">
                <ScanSearch className="w-4 h-4" />
                <span>RMA</span>
              </Link>
            )}
            {isSuperAdmin && (
              <Link to="/feedback" className="header-nav-link" title="SOP Feedback">
                <MessageCircle className="w-4 h-4" />
                <span>Feedback</span>
              </Link>
            )}
            {authStatus === "authenticated" && (
              <Link to="/settings" className="header-nav-link">
                <User className="w-4 h-4" />
                <span>Profile</span>
              </Link>
            )}
            {authStatus === "authenticated" && (
              <button
                type="button"
                className="header-nav-link"
                title="Sign out"
                onClick={() => {
                  navigate("/login", { state: { from: null }, replace: true });
                  clearSessionOnLogout();
                  signOut();
                }}
              >
                <LogOut className="w-4 h-4" />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
